<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="frame132" /> <a href="#">{{ name }}<i class="el-icon-arrow-down" /> </a> 
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item command="en">
        English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
   data() {
     return {
       name: '中文'
     }
   },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      if (lang === 'en') {
         this.name = 'English'
         this.$message({
          message: '切换为英文',
          type: 'success'
         })
      } else if (lang === 'zh') {
         this.name = '中文'
         this.$message({
          message: '切换为中文',
          type: 'success'
        })
      } 
    }
  }
}
</script>
<style lang="scss" scoped>
a{
  font-size: 12px;
  color: #333;
}
.svg-icon{
  color: #333 !important;
}
</style>
